<template>
	<component
		:is="itemType"
		:item="item"
		:removable="removable"
		:index="index"
		:key="index"
	></component>
</template>

<script>
import SimpleFavorite from './simple-favorites';

export default {
	mixins: [SimpleFavorite],

	computed: {
		itemType() {
			return this.item.model_code + '-card-horizontal';
		}
	},

	created() {
		if(this.removable) this.item['removable'] = true;
	}
}
</script>
